import Field, { PasswordField } from '../../components/ui/Field';
import AuthContainer from '../../components/containers/AuthContainer';
import ReCAPTCHA from 'react-google-recaptcha';
import env from '../../config/env';
import { useRef, useState } from 'react';
import api from '../../config/axios';
import { toast } from 'react-toastify';
import { useUserContext } from '../../App';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const recaptchaRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const { setUser } = useUserContext();

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        // console.log("data", recaptchaRef.current);
        // const captchaToken = await recaptchaRef.current.executeAsync();
        // recaptchaRef.current.reset();

        const data = {
            username: e.target.username.value,
            password: e.target.password.value,
            // captchaToken,
        };
        console.log(data);

        await api
            .post('/auth/admin-login', data)
            .then((res) => {
                toast.success(res.data.message);
                localStorage.setItem('token', res.data.accessToken);
                // window.location.href = "/"
                api.get('/auth/admin-access')
                    .then((res) => {
                        setUser(res.data);
                        navigate('/');
                    })
                    .finally(() => setLoading(false));
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => setLoading(false));
    };
    return (
        <AuthContainer
            title="Admin Access"
            subtitle="Enter your details to get Lefoperations Admin Access"
            submitText="Log In"
            submit={handleSubmit}
            loading={loading}>
            <Field
                color="secondary"
                label="Admin Username"
                placeholder="Enter your username"
                name="username"
                required
            />

            <PasswordField
                color="secondary"
                label="Admin Password"
                placeholder="Enter your password"
                name="password"
                required
            />
            {/* <ReCAPTCHA ref={recaptchaRef} sitekey={env.RECAPTCHA_KEY} size="invisible" /> */}
        </AuthContainer>
    );
};

export default Login;
